import View from "../common/publi/socialShare";
import components from "./components.js";
components.define("js-share", View);